import { useContext, useEffect } from "react";
import { ContextNav, ContextLoading, ContextDashboard } from "../../../context";
import { BrowserRouter, Routes, Route, useLocation, Link } from "react-router-dom";
import {
    Dashboard,
    Rollcall,
    RollcallAdd,
    RollcallEdit,
    Delay,
    OverTime,
    Absence,
    Vacation,
    VacationAdd,
    VacationEdit,
    Users,
    UsersAdd,
    UsersEdit,
    JobGroups,
    JobGroupsAdd,
    JobGroupsEdit,
    Job,
    JobAdd,
    JobEdit,
    Operations,
    OperationsAdd,
    OperationsEdit,
    VcationReasons,
    VcationReasonsAdd,
    VcationReasonsEdit,
    DelayReasons,
    DelayReasonsAdd,
    DelayReasonsEdit,
    Holidays,
    HolidaysAdd,
    HolidaysEdit,
    Schedules,
    SchedulesAdd,
    SchedulesEdit,
    Company,
    Location,
    LocationAdd,
    LocationEdit,
    Ticket,
    TicketAdd,
    PurchaseHistory,
    Plan,
    PlanResult,
    AccessLevel,
    AccessLevelAdd,
    AccessLevelEdit,
    AdminAdd,
    Admin,
    AdminEdit ,
    Module ,
    ModuleResult
} from "../../../pages";
import { ProtectedRoute, DashboardApi, PlanApi, ProfileApi , NavListApi } from "../../../api";
import { PageLoader, PageLoaderOpacity } from "../Loasder";
import { Test } from "../../../pages/test/Test";
import { CheckPermission } from "../checkPermission";


export const Count = (props: any) => {
    const CtxNav = useContext(ContextNav)
    const CtxLoad = useContext(ContextLoading)
    const CtxDash = useContext(ContextDashboard)
    const location = useLocation()


    const getNavList = async () => {
        if (CtxNav.navList.length == 0) {
            try {
                CtxLoad.setDisplayNavSkelton(true)
                let res:any = await NavListApi()                                
                CtxNav.setNavList(res.data.data.menu)
                CtxLoad.setDisplayNavSkelton(false)
            }
            catch (err: any) {
                CtxLoad.setDisplayNavSkelton(false)
            }
        }
    }

    const getDashoardInfo = async () => {
        if (CtxDash.dashboard == null) {
            try {
                CtxLoad.setDisplayLoadingSkelton(true)
                let res = await DashboardApi()
                CtxDash.setDashboard(res.data.data)
                CtxLoad.setDisplayLoadingSkelton(false)
            }
            catch (err: any) {
                CtxLoad.setDisplayLoadingSkelton(false)
            }
        }
    }

    const getProfileInfo = async () => {
        if (CtxDash.profile == null) {
            try {
                let res = await ProfileApi()
                CtxDash.setProfile(res.data.data[0])
                CtxDash.setEmployees(res.data.data[0].company.users)
                CtxDash.setLocation(res.data.data[0].company.qr_codes)
                if (res.data.data[0].is_owner == true) {
                    localStorage.setItem('groupAccess', '-1')
                }
            }
            catch (err: any) {
            }
        }
    }

    const getPlanInfo = async () => {
        if (CtxDash.plan == null) {
            try {
                let res = await PlanApi()
                CtxDash.setPlan(res.data.data)
            }
            catch (err: any) {
            }
        }
    }

    useEffect(() => {
        CtxNav.setDisplayNavMobile(false)
    }, [location])

    useEffect(() => {
        getDashoardInfo()
        getPlanInfo()
        getProfileInfo()
        getNavList()
    }, [])

    return (
        <>
            {CtxLoad.displayLoading && <PageLoader />}
            {CtxLoad.displayLoadingBlur && <PageLoaderOpacity />}
            <div className="w-full md:w-[calc(100%-270px)] min-h-screen relative  flex flex-col py-[10px] sm:py-[20px] px-[10px] md:px-[20px] transition-all">
                <div className=" w-full  mt-[7px] flex sm:flex-row flex-col items-center justify-center lg:justify-end">
                    <div className=" w-full   flex md:hidden justify-between items-center" >
                        <div onClick={() => { CtxNav.setDisplayNavMobile(!CtxNav.displayNavMobile) }} className="w-[40px] h-[40px] flex items-center justify-center text-xs text-dayan-orange-50 cursor-pointer rounded-[10px] border border-dayan-orange-50">
                            <svg x="0px" y="0px" viewBox="0 0 32 32" className={`  h-5 fill-dayan-orange-50 `}>
                                <use xlinkHref="/assetes/svg/align-right.svg#align" />
                            </svg>
                        </div>
                        <Link to='/'>
                            <img src="/assetes/logo/logo.png" alt="logo" className=" h-[60px] cursor-pointer" />
                        </Link>
                        <div className="w-[40px]" />
                    </div>
                    <div className=" w-fit hidden md:flex items-center">
                        {CheckPermission(39) &&
                            <Link to='/p/ticket'>
                                <div className=" w-[40px] h-[40px] rounded-lg bg-dayan-gray-80 flex justify-center items-center mb-[4px] mt-[7px] ml-[10px]">
                                    <img src='/assetes/svg/message.svg' className=" w-[20px]" />
                                </div>
                            </Link>
                        }
                        {CheckPermission(37) &&
                            <div className="w-[100px] sm:w-[150px] ml-[10px] flex flex-col items-center sm:items-start">
                                <span className="text-[11px] ">پلن فعلی شما </span>
                                <div className=" w-full h-[40px] text-xs bg-dayan-gray-200 mb-[4px] mt-[7px] rounded-lg flex justify-center items-center text-white">
                                    <span>{CtxDash.plan?.active_plan}</span>
                                </div>

                                <div className=" w-full flex justify-center sm:justify-between items-center">
                                    <span className="text-[10px] ">{CtxDash.dashboard?.plan_remaining_days} روز باقی مانده</span>
                                    <div className=" w-[70px] hidden sm:flex h-[5px] rounded bg-dayan-gray-200 overflow-hidden">
                                        <div className=" h-[5px] rounded bg-dayan-orange-50" style={{ width: CtxDash.plan?.remaining_days ? `${(100 * +CtxDash.plan?.remaining_days) / +CtxDash.plan?.total_days}%` : '0' }} />
                                    </div>
                                </div>
                            </div>
                        }
                        {CheckPermission(36) &&
                            <Link to={'/p/plan'}>
                                <div className="w-[80px] h-[40px] rounded-lg bg-dayan-orange-50 mb-[4px] mt-[7px] flex justify-center items-center text-xs text-white">
                                    <span>تمدید / ارتقا</span>
                                </div>
                            </Link>
                        }
                    </div>
                </div>
                <div className="w-full mt-[20px] md:mt-[50px]">
                    {props.children}
                    <Routes>
                        <Route path="dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />

                        <Route path="reports/rollcall" element={<ProtectedRoute><Rollcall /></ProtectedRoute>} />
                        <Route path="reports/rollcall/add" element={<ProtectedRoute><RollcallAdd /></ProtectedRoute>} />
                        <Route path="reports/rollcall/:id" element={<ProtectedRoute><RollcallEdit /></ProtectedRoute>} />

                        <Route path="reports/delay" element={<ProtectedRoute><Delay /></ProtectedRoute>} />

                        <Route path="reports/overtime" element={<ProtectedRoute><OverTime /></ProtectedRoute>} />

                        <Route path="reports/absence" element={<ProtectedRoute><Absence /></ProtectedRoute>} />

                        <Route path="reports/vacation" element={<ProtectedRoute><Vacation /></ProtectedRoute>} />
                        <Route path="reports/vacation/add" element={<ProtectedRoute><VacationAdd /></ProtectedRoute>} />
                        <Route path="reports/vacation/:id" element={<ProtectedRoute><VacationEdit /></ProtectedRoute>} />

                        <Route path="users" element={<ProtectedRoute><Users /></ProtectedRoute>} />
                        <Route path="users/add" element={<ProtectedRoute><UsersAdd /></ProtectedRoute>} />
                        <Route path="users/:id" element={<ProtectedRoute><UsersEdit /></ProtectedRoute>} />

                        <Route path="settings/job-groups" element={<ProtectedRoute><JobGroups /></ProtectedRoute>} />
                        <Route path="settings/job-groups/add" element={<ProtectedRoute><JobGroupsAdd /></ProtectedRoute>} />
                        <Route path="settings/job-groups/:id" element={<ProtectedRoute><JobGroupsEdit /></ProtectedRoute>} />

                        <Route path="settings/job" element={<ProtectedRoute><Job /></ProtectedRoute>} />
                        <Route path="settings/job/add" element={<ProtectedRoute><JobAdd /></ProtectedRoute>} />
                        <Route path="settings/job/:id" element={<ProtectedRoute><JobEdit /></ProtectedRoute>} />

                        <Route path="settings/operations" element={<ProtectedRoute><Operations /></ProtectedRoute>} />
                        <Route path="settings/operations/add" element={<ProtectedRoute><OperationsAdd /></ProtectedRoute>} />
                        <Route path="settings/operations/:id" element={<ProtectedRoute><OperationsEdit /></ProtectedRoute>} />

                        <Route path="settings/vacation-reasons" element={<ProtectedRoute><VcationReasons /></ProtectedRoute>} />
                        <Route path="settings/vacation-reasons/add" element={<ProtectedRoute><VcationReasonsAdd /></ProtectedRoute>} />
                        <Route path="settings/vacation-reasons/:id" element={<ProtectedRoute><VcationReasonsEdit /></ProtectedRoute>} />

                        <Route path="settings/delay-reasons" element={<ProtectedRoute><DelayReasons /></ProtectedRoute>} />
                        <Route path="settings/delay-reasons/add" element={<ProtectedRoute><DelayReasonsAdd /></ProtectedRoute>} />
                        <Route path="settings/delay-reasons/:id" element={<ProtectedRoute><DelayReasonsEdit /></ProtectedRoute>} />

                        <Route path="settings/holidays" element={<ProtectedRoute><Holidays /></ProtectedRoute>} />
                        <Route path="settings/holidays/add" element={<ProtectedRoute><HolidaysAdd /></ProtectedRoute>} />
                        <Route path="settings/holidays/:id" element={<ProtectedRoute><HolidaysEdit /></ProtectedRoute>} />

                        <Route path="settings/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
                        <Route path="settings/admin/add" element={<ProtectedRoute><AdminAdd /></ProtectedRoute>} />
                        <Route path="settings/admin/:id" element={<ProtectedRoute><AdminEdit /></ProtectedRoute>} />

                        <Route path="settings/access-level" element={<ProtectedRoute><AccessLevel /></ProtectedRoute>} />
                        <Route path="settings/access-level/add" element={<ProtectedRoute><AccessLevelAdd /></ProtectedRoute>} />
                        <Route path="settings/access-level/:id" element={<ProtectedRoute><AccessLevelEdit /></ProtectedRoute>} />

                        <Route path="settings/schedules" element={<ProtectedRoute><Schedules /></ProtectedRoute>} />
                        <Route path="settings/schedules/add" element={<ProtectedRoute><SchedulesAdd /></ProtectedRoute>} />
                        <Route path="settings/schedules/:id" element={<ProtectedRoute><SchedulesEdit /></ProtectedRoute>} />

                        <Route path="company" element={<ProtectedRoute><Company /></ProtectedRoute>} />

                        <Route path="location" element={<ProtectedRoute><Location /></ProtectedRoute>} />
                        <Route path="location/add" element={<ProtectedRoute><LocationAdd /></ProtectedRoute>} />
                        <Route path="location/:id" element={<ProtectedRoute><LocationEdit /></ProtectedRoute>} />

                        <Route path="module" element={<ProtectedRoute><Module /></ProtectedRoute>} />
                        <Route path="module-result" element={<ProtectedRoute><ModuleResult /></ProtectedRoute>} />

                        <Route path="ticket" element={<ProtectedRoute><Ticket /></ProtectedRoute>} />
                        <Route path="ticket/add" element={<ProtectedRoute><TicketAdd /></ProtectedRoute>} />

                        <Route path="purchase-history" element={<ProtectedRoute><PurchaseHistory /></ProtectedRoute>} />

                        <Route path="plan" element={<ProtectedRoute><Plan /></ProtectedRoute>} />
                        <Route path="plan-result" element={<ProtectedRoute><PlanResult /></ProtectedRoute>} />

                        <Route path="test" element={<ProtectedRoute><Test /></ProtectedRoute>} />


                    </Routes>
                </div>
            </div>
        </>
    );
}